export const OrderCardSkeleton = () => (
  <li className="ord-card is-skeleton" aria-hidden="true">
    <span className="ord-card-button">
      <span className="ord-card-head">
        <span className="ord-shimmer ord-shimmer-number" />
        <span className="ord-shimmer ord-shimmer-status" />
      </span>

      <span className="ord-card-rule" />

      <span className="ord-supplier">
        <span className="ord-shimmer ord-shimmer-avatar" />
        <span className="ord-shimmer ord-shimmer-line ord-shimmer-supplier" />
      </span>

      <span className="ord-facts">
        {Array.from({ length: 4 }, (unused, index) => (
          <span className="ord-fact" key={index}>
            <span className="ord-shimmer ord-shimmer-label" />
            <span className="ord-shimmer ord-shimmer-value" />
          </span>
        ))}
      </span>
    </span>
  </li>
);

export const OrderListSkeleton = ({ cards = 6 }) => (
  <ul className="ord-list" aria-hidden="true">
    {Array.from({ length: cards }, (unused, index) => (
      <OrderCardSkeleton key={index} />
    ))}
  </ul>
);

const Bone = ({ className = "", width }) => (
  <span className={`ord-bone ${className}`} style={{ width }}>
    {"\u00a0"}
  </span>
);

const BoneRow = ({ label, value }) => (
  <div className="ord-receipt-row">
    <Bone className="ord-receipt-label" width={label} />
    <Bone className="ord-receipt-value" width={value} />
  </div>
);

const PanelTitleBone = () => (
  <div className="ord-panel-title ord-bone-fill">{"\u00a0"}</div>
);

const moneyRows = [
  ["70px", "56px"],
  ["118px", "44px"],
  ["92px", "44px"],
  ["96px", "44px"],
  ["88px", "60px"],
];

const deliveryRows = [
  ["0px", "112px"],
  ["72px", "84px"],
  ["104px", "70px"],
];

export const OrderDetailSkeleton = () => (
  <div className="ord-detail-grid" aria-hidden="true">
    <div className="ord-main">
      <section className="ord-panel ord-panel-compact">
        <div className="ord-panel-head ord-order-head">
          <Bone className="ord-card-number" width="140px" />
          <Bone className="ord-placed-at" width="130px" />
        </div>
      </section>

      <section className="ord-panel ord-receipt">
        <div className="ord-supplier">
          <span className="ord-shimmer ord-shimmer-avatar" />
          <Bone className="ord-supplier-name" width="160px" />
        </div>

        <div className="ord-receipt-items">
          <BoneRow label="180px" value="56px" />
        </div>

        <div className="ord-receipt-rule" />

        <div className="ord-receipt-money">
          {moneyRows.map(([label, value], index) => (
            <BoneRow key={index} label={label} value={value} />
          ))}
        </div>

        <div className="ord-receipt-money ord-receipt-payments">
          <BoneRow label="100px" value="36px" />
          <BoneRow label="116px" value="52px" />
        </div>

        <div className="ord-receipt-total">
          <Bone width="56px" />
          <Bone width="80px" />
        </div>

        <div className="ord-actions">
          <span className="ord-btn ord-bone-fill" style={{ width: 158 }} />
          <span className="ord-btn ord-bone-fill" style={{ width: 136 }} />
        </div>
      </section>
    </div>

    <div className="ord-side">
      <section className="ord-panel">
        <div className="hex-card-container content-card">
          <PanelTitleBone />

          {deliveryRows.map(([label, value], index) => (
            <div
              className="view-detail-content flex align-center justify-between mb-8"
              key={index}
            >
              <Bone className="font-12-normal-400-lh-14" width={label} />
              <Bone className="font-12-normal-400-lh-14" width={value} />
            </div>
          ))}
        </div>

        <p className="ord-eta">
          <Bone className="ord-eta-label" width="104px" />
          <Bone className="ord-eta-value" width="150px" />
        </p>
      </section>

      <section className="ord-panel">
        <PanelTitleBone />

        <ol className="ord-track">
          {Array.from({ length: 4 }, (unused, index) => (
            <li className="ord-track-item" key={index}>
              <span className="ord-track-marker">
                <span className="ord-track-dot" />
              </span>

              <span className="ord-track-body">
                <span className="ord-track-text">
                  <Bone className="ord-track-title" width="110px" />
                  <Bone className="ord-track-sub" width="160px" />
                </span>
              </span>
            </li>
          ))}
        </ol>
      </section>
    </div>
  </div>
);

export default OrderCardSkeleton;
